import React, { useEffect, useState, version } from "react";
import { API, DataStore } from 'aws-amplify';
import { Farm, Varieties } from '../../models';
import { StyleSheet, Text, TouchableOpacity, View, SafeAreaView, TextInput, ScrollView, Image } from 'react-native';
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { SaveDialog } from "../components/CmnDiaLog";
import { googleMapsApiKey } from "../components/AppConst";
import { getCurrentUser, appMsg, appAlert, sleep, varietiesCnv } from "../components/CmnUtil";
import * as Location from 'expo-location';
import { Header } from "../components/Header";
import IconImages from '../components/IconImages';
// @ts-ignore
import { MultipleSelectPicker } from 'react-native-multi-select-picker';
import { GraphQLResult } from '@aws-amplify/api-graphql'
import { createFarm, updateFarm as updateFarmTmpl, deleteFarm as deleteFarmTmpl } from "../../graphql/mutations";
import { CreateFarmMutation, DeleteFarmMutation, ListFarmsQuery, UpdateFarmMutation } from "../../API";
import { listFarms } from "../../graphql/queries";

/** ================================
*  圃場詳細画面
*  ================================*/
const FarmDetail = ({ navigation, route }: { navigation: any, route: any; }) => {

  // 圃場の名前格納State
  const [name, setName] = useState<string>("");

  // 圃場のメモ格納State
  const [memo, setMemo] = useState<string | undefined>("");

  // 圃場の緯度格納State
  const [lat, setLat] = useState<number | undefined>();

  // 圃場の経度格納State
  const [lng, setLng] = useState<number | undefined>();

  // 圃場ID格納State
  const [farmId, setFarmId] = useState<string>("");

  // 新規作成と変更のモード
  const [mode, setMode] = useState<string>("");

  // 保存ダイアログ表示State
  const [dialogFlag, setDialogFlag] = useState<boolean>(false);

  // ダイアログの種類格納State
  const [dialogMode, setDialogMode] = useState<string>("");

  // 圃場初期位置
  const [firstLocation, setFirstLocation] = useState<{ lat: number, lng: number; }>({ lat: 35.7, lng: 140.2 });

  // GoogleMap用
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey,
  });

  // 栽培品種選択肢
  const items = Object.entries(Varieties).map((item) => { return { label: varietiesCnv(item[1]), value: item[1] } });

  // 栽培品種選択開閉
  const [pickerOpen, setPickerOpen] = useState(false);

  // 選択栽培品種
  const [selectectedItems, setSelectectedItems] = useState<{ label: string; value: string; }[]>([]);

  // 圃場ID格納処理＆モードをセット
  useEffect(() => {
    if (!(route.params === undefined)) {
      setFarmId(route.params.id);
      setMode("edit");
    } else {
      setFarmId("");
      setMode("create");
    };
  }, [route.params]);

  // 圃場情報取得処理
  const queryFarm = async () => {
    const res = (await API.graphql({
      query: listFarms,
      variables: {
        filter: {
          id: {eq: farmId}
        }
      },
    })) as GraphQLResult<ListFarmsQuery>
    return res.data?.listFarms?.items as unknown as Farm[]
  };

  const getFarmCurrentVersion = async () => {
    const res = (await API.graphql({
      query: listFarms,
      variables: {
        filter: {
          id: {eq: farmId}
        }
      },
    })) as GraphQLResult<ListFarmsQuery>
    return res.data?.listFarms?.items[0]?._version
  }

  /**
   * 圃場を新規作成する
   * @returns {Promise<string[]>} [status, message]
   */
  const saveFarm = async (): Promise<string[]> => {
    const appUser = await getCurrentUser();
    try {
      if (appUser && lat !== undefined && lng !== undefined && name !== "") {
        const res = (await API.graphql({
          query: createFarm,
          variables: {
            input: {
              groupID: appUser.group.id,
              name: name,
              lat: lat,
              lng: lng,
              memo: memo,
              varieties: selectectedItems.map(i => i.value)
            }
          },
        })) as GraphQLResult<CreateFarmMutation>
        if (res.errors) {
          throw res.errors
        }
        return ["success", "保存に成功しました。"];
      } else {
        throw new Error("error");
      };
    } catch (err) {
      console.error(err)
      return ["error", "保存に失敗しました。"];
    };
  };

  /**
   * 圃場情報を更新する
   * @returns {Promise<string[]>} [status, message]
   */
  const updateFarm = async (): Promise<string[]> => {
    const appUser = await getCurrentUser();
    const farm: Farm[] = await queryFarm();
    const _version = await getFarmCurrentVersion();
    console.log(farm[0], _version)
    try {
      if (appUser && farm && lat !== undefined && lng !== undefined && name !== "") {
        const res = (await API.graphql({
          query: updateFarmTmpl,
          variables: {
            input: {
              id: farm[0].id,
              name: name,
              lat: lat,
              lng: lng,
              memo: memo,
              varieties: selectectedItems.map(i => i.value),
              _version: _version
            }
          },
        })) as GraphQLResult<UpdateFarmMutation>
        if (res.errors) {
          throw res.errors
        }
        return ["success", "情報を変更しました。"];
      } else {
        throw new Error("error");
      };
    } catch (err) {
      console.error(err)
      return ["error", "変更に失敗しました。"];
    };
  };

  /**
   * 圃場情報削除処理
   * @returns {Promise<string[]>} [status, message]
   */
  const deleteFarm = async (): Promise<string[]> => {
    const farm: Farm[] = await queryFarm();
    const _version = await getFarmCurrentVersion();
    try {
      if (farm.length != 0) {
        const res = (await API.graphql({
          query: deleteFarmTmpl,
          variables: {
            input: {
              id: farm[0].id,
              _version: _version
            }
          },
        })) as GraphQLResult<DeleteFarmMutation>
        if (res.errors) {
          throw res.errors
        }
        return ["success", "圃場を削除しました。"];
      } else {
        throw new Error("error");
      };
    } catch (err) {
      console.error(err)
      return ["error", "削除に失敗しました。"];
    };
  };

  // 圃場情報をあらかじめ入力する処理
  useEffect(() => {
    (async () => {
      if (mode == "edit") {
        const farm: Farm[] = await queryFarm();
        setName(farm[0].name);
        setMemo(farm[0].memo ? farm[0].memo : "");
        setLat(farm[0].lat);
        setLng(farm[0].lng);
        setFirstLocation({ lat: farm[0].lat, lng: farm[0].lng });
        const tmpVarieties = [];
        if (farm[0].varieties) {
          for (const variety of farm[0].varieties) {
            if (variety) {
              tmpVarieties.push({ label: varietiesCnv(variety), value: variety });
            }
          }
        }
        setSelectectedItems(tmpVarieties);
      } else if (mode == "create") {
        setName("");
        setMemo("");
        let { status } = await Location.requestForegroundPermissionsAsync();// 位置情報取得許可
        if (status !== 'granted') {// 拒否された場合エラーメッセージを設定してreturn
          return;
        };

        let location = await Location.getCurrentPositionAsync({});// 位置情報取得
        if (location) {
          setLat(location.coords.latitude);
          setLng(location.coords.longitude);
          setFirstLocation({ lat: location.coords.latitude, lng: location.coords.longitude });
        };
        const tmpVarieties = [];
        for (const variety of Object.entries(Varieties)) {
          // その他以外の全ての品種を選択
          if (variety[1] != Varieties.OTHERS) {
            tmpVarieties.push({ label: varietiesCnv(variety[1]), value: variety[1] });
          }
        }
        setSelectectedItems(tmpVarieties);
      };
    })();
  }, [mode]);

  // 圃場の緯度経度格納処理
  const onClickMap = (location: google.maps.MapMouseEvent) => {
    if (location.latLng != null) {
      setLat(location.latLng?.lat());
      setLng(location.latLng?.lng());
    };
  };

  // 保存or削除ボタンクリック
  const onClickSaveDelete = (dialogMode: string) => {
    setDialogFlag(true);
    setDialogMode(dialogMode);
  };

  /**
   * ダイアログに表示されたボタンをクリックし
   * 「新規作成」「情報変更」「削除」「キャンセル」により
   * 処理内容を変更
   * @param dialogMode string : create, edit, delete, cancelのいずれか
   * @returns 
   */
  const onClickDialogButton = async (dialogMode: string) => {
    setDialogFlag(false);

    // キャンセル押下で何もせずリターン
    if (dialogMode === "cancel") { return; };
    let msgText: string[] = ["error", "例外が発生しました。"];
    if (dialogMode === "delete") {
      await deleteFarm().then((res) => msgText = res);
    } else {
      if (lat == undefined || lng == undefined || name === "") {
        msgText[1] = "圃場位置・圃場名は必須入力です。";
      } else {
        if (dialogMode === "create") {
          await saveFarm().then((res) => msgText = res);
        } else if (dialogMode === "edit") {
          await updateFarm().then((res) => msgText = res);
        };
      };
    };

    if (msgText[0] == "success") {
      await appMsg(msgText[1]);
      if (dialogMode === "create" || dialogMode === "delete") {
        await sleep(2500);
        navigation.goBack();
      };
    } else if (msgText[0] == "error") {
      await appAlert(msgText[1]);
    };
  };

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView>
        <SaveDialog
          cancelButtonName={"キャンセル"}
          saveButtonName={dialogMode == "delete" ? "削除" : "保存"}
          canceAction={() => onClickDialogButton("cancel")}
          saveAction={() => onClickDialogButton(dialogMode)}
          message={dialogMode == "create" ? "この内容で保存しますか？" : (dialogMode == "edit" ? "変更を保存しますか？" : "本当に削除しますか？")}
          visible={dialogFlag}
        />

        <Header onPress={() => navigation.goBack()} goBackText="＜" headerText={mode == "edit" ? "圃場情報変更/圃場削除" : "新規圃場登録"} />

        <View style={styles.formBlock} >
          <Text style={styles.formText}>圃場位置情報</Text>

          {/* グーグルマップ */}
          {loadError ?
            <Text>Map cannot be loaded right now, sorry.</Text>
            :
            isLoaded ?
              <GoogleMap
                mapContainerStyle={{ width: "90%", height: "220px", marginRight: "auto", marginLeft: "auto", }}
                center={firstLocation}
                zoom={18}
                options={{
                  zoomControl: false,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  mapTypeId: "hybrid",
                }}
                onClick={e => onClickMap(e)}
              >
                {lat != undefined && lng != undefined && <Marker position={{ lat: lat, lng: lng }} />}
              </GoogleMap>
              :
              <Text>loading...</Text>
          }

          <View style={{ width: "90%", marginHorizontal: "auto", }}>
            <Text style={styles.descriptionText}>1.地図をスクロールして圃場付近まで移動してください</Text>
            <Text style={styles.descriptionText}>2.圃場をタップするとピンが置かれ、位置を設定できます。</Text>
          </View>
        </View>

        <View style={styles.formBlock}>
          <Text style={styles.formText}>圃場名</Text>
          <TextInput
            style={styles.formInputName}
            placeholder="<例>&#9675;&#9675;農園"
            onChangeText={text => setName(text)}
            value={name}
          />
        </View>

        <View style={styles.formBlock}>
          <Text style={styles.formText}>栽培品種</Text>
          <TouchableOpacity
            onPress={() => { setPickerOpen(!pickerOpen) }}
            style={styles.formInputVarieties}
          >
            {selectectedItems.length == 0 ?
              <Text style={styles.formInputVarietiesText}>選択してください</Text>
              :
              <Text style={styles.formInputVarietiesText}>{selectectedItems.map((item) => { return item["label"] }).join("・")}</Text>
            }
            <Image style={{ height: 20, width: 20, marginRight: 20 }} source={pickerOpen ? IconImages.icUpArrowBlack : IconImages.icDownArrowBlack} />
          </TouchableOpacity>
          {pickerOpen && <MultipleSelectPicker
            items={items}
            onSelectionsChange={(ele: any) => { setSelectectedItems(ele); }}
            selectedItems={selectectedItems}
            checkboxStyle={{ height: 20, width: 20 }}
            selectedCheckboxSource={IconImages.icCheckOn}
          />}
        </View>

        <View style={styles.formBlock}>
          <Text style={styles.formText}>圃場メモ</Text>
          <TextInput
            multiline
            numberOfLines={4}
            editable
            style={styles.formMemo}
            onChangeText={text => setMemo(text)}
            value={memo}
          />
        </View>
        <TouchableOpacity style={styles.button} onPress={() => onClickSaveDelete(mode)}>
          <Text style={styles.buttonText}>保存</Text>
        </TouchableOpacity>
        {(mode == "edit") &&
          <TouchableOpacity style={styles.deleteFarm} onPress={() => onClickSaveDelete("delete")}>
            <Text style={styles.deleteFarmText}>この圃場を削除する</Text>
          </TouchableOpacity>
        }
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#E2F0D9",
  },
  descriptionText: {
    fontSize: 12,
  },
  button: {
    backgroundColor: "#7AAD47",
    borderWidth: 1,
    borderColor: "#057E32",
    borderStyle: "solid",
    width: 120,
    marginHorizontal: "auto",
    height: 40,
    justifyContent: 'center',
    shadowColor: "#808080",
    shadowOffset: { width: 5, height: 5 },
    shadowRadius: 10,
  },
  buttonText: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: 18,
  },
  formBlock: {
    marginBottom: 15,
  },
  formInputName: {
    backgroundColor: "#FFFFFF",
    height: 40,
    fontSize: 18,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "#417B9C",
    paddingHorizontal: 25,
  },
  formInputVarieties: {
    backgroundColor: "#FFFFFF",
    height: 40,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "#417B9C",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  formInputVarietiesText: {
    fontSize: 18,
    paddingHorizontal: 25,
  },
  formMemo: {
    backgroundColor: "#FFFFFF",
    height: 80,
    fontSize: 18,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "#417B9C",
    paddingHorizontal: 25,
    paddingVertical: 5,
  },
  formText: {
    fontSize: 18,
    marginBottom: 5,
    marginLeft: 20,
  },
  goBackScreenAllow: {
    fontSize: 18,
    fontWeight: "bold",
  },
  deleteFarm: {
    width: "auto",
    marginVertical: 50,
    marginHorizontal: "auto",
  },
  deleteFarmText: {
    color: "#ff0000",
    fontSize: 18,
    textDecorationLine: "underline",
    textAlign: "center",
  }
});

export default FarmDetail;
